module.exports = __webpack_public_path__ + "static/media/crypto-pay-confirm.23ce9e03.png";